module.exports = __webpack_public_path__ + "01_very_short_grey.22b17df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_very_short_grey.png
// module id = HnpP
// module chunks = 0